export default {
  SEARCH_MY_INVESTMENT_CUSTOMER_DOCUMENTS_QUERY: Symbol.for('SEARCH_MY_INVESTMENT_CUSTOMER_DOCUMENTS_QUERY'),
  MY_INVESTMENT_CUSTOMER_DOCUMENTS_REPOSITORY: Symbol.for('MY_INVESTMENT_CUSTOMER_DOCUMENTS_REPOSITORY'),
  MY_INVESTMENT_CUSTOMER_DOCUMENTS_STATE_MANAGER: Symbol.for('MY_INVESTMENT_CUSTOMER_DOCUMENTS_STATE_MANAGER'),
};
